import React from "react";

export default function Commitment() {
  return (
    <div>
      <svg
        width="30"
        height="36"
        viewBox="0 0 30 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M29.7102 35.7635H0.291016C0.29381 35.6126 0.297535 35.4608 0.297535 35.3099C0.297535 24.3918 0.297535 13.4728 0.297535 2.55467V2.08434H6.6353V0H23.3668V2.11042H29.7037C29.7037 2.29203 29.7037 2.44104 29.7037 2.58912C29.7037 13.496 29.7037 24.403 29.7037 35.309C29.7037 35.4598 29.7083 35.6116 29.7102 35.7625V35.7635ZM6.59339 4.22456H2.4182V33.6381H27.5802V4.22642H23.3836V6.27723H6.59339V4.22456ZM21.2732 2.12159H8.73454V4.17333H21.2732V2.12159Z"
          fill="#F6F6F6"
        />
        <path
          d="M11.1984 20.1429C11.2972 19.3438 11.3884 18.596 11.4816 17.849C11.5514 17.2837 11.6362 16.7193 11.6846 16.1521C11.6949 16.0292 11.6073 15.8699 11.516 15.7712C10.7291 14.9153 9.9309 14.0687 9.13739 13.2194C9.05357 13.1299 8.97255 13.0387 8.84961 12.9036C9.68409 12.7406 10.4543 12.5907 11.2245 12.4408C11.7144 12.3458 12.209 12.2694 12.6914 12.1483C12.846 12.1092 13.0248 11.9844 13.1021 11.8466C13.6823 10.8267 14.2402 9.79388 14.8065 8.76568C14.8605 8.66789 14.9229 8.57476 15.0086 8.43506C15.2433 8.85882 15.4556 9.24067 15.667 9.62345C16.0759 10.3667 16.4745 11.1164 16.901 11.8484C16.9802 11.9844 17.16 12.1139 17.3136 12.1455C18.5178 12.3951 19.7267 12.6196 20.9347 12.8533C20.9878 12.8636 21.0399 12.885 21.1414 12.9157C21.0297 13.0377 20.9477 13.1299 20.8639 13.2194C20.0695 14.0687 19.2694 14.9125 18.488 15.7731C18.3837 15.8886 18.3176 16.0991 18.3344 16.2546C18.4601 17.3992 18.6119 18.5401 18.7535 19.6829C18.7702 19.8179 18.7768 19.9548 18.7917 20.1439C18.3055 19.9166 17.8668 19.7117 17.4282 19.5059C16.7036 19.166 15.9837 18.8139 15.2507 18.4935C15.1082 18.4311 14.8893 18.4339 14.7469 18.4982C13.6786 18.9797 12.6215 19.4854 11.5598 19.9818C11.4583 20.0293 11.354 20.0712 11.1966 20.1401L11.1984 20.1429ZM16.2035 16.683C16.2174 16.6467 16.2314 16.6104 16.2454 16.574C16.2044 16.2518 16.1737 15.9286 16.1187 15.6092C16.0759 15.3577 16.1299 15.1668 16.3245 14.9898C16.5602 14.7747 16.7669 14.526 17.024 14.2513C16.6365 14.174 16.3106 14.0892 15.9799 14.051C15.7406 14.0231 15.6102 13.9076 15.5087 13.7046C15.3606 13.4093 15.193 13.1234 15.002 12.777C14.8055 13.1327 14.6649 13.4391 14.4749 13.7111C14.3752 13.8536 14.2039 13.9821 14.039 14.0333C13.7149 14.1349 13.3731 14.1786 12.9838 14.2578C13.2576 14.5484 13.5063 14.7784 13.7103 15.042C13.8109 15.1724 13.8816 15.3661 13.877 15.5291C13.8677 15.883 13.8025 16.236 13.7596 16.5917C13.7987 16.5917 13.8127 16.5964 13.8211 16.5917C14.6146 16.0776 15.4081 15.937 16.2035 16.6849V16.683Z"
          fill="#F6F6F6"
        />
        <path
          d="M4.4984 27.3224C4.4984 26.678 4.49188 26.0623 4.50771 25.4477C4.50958 25.3769 4.62599 25.2893 4.70795 25.2474C4.77315 25.2148 4.86721 25.24 4.94824 25.24C11.6502 25.24 18.353 25.24 25.0549 25.24C25.3536 25.24 25.5029 25.3915 25.5029 25.6945C25.5029 26.2281 25.5029 26.7618 25.5029 27.3224H4.4984Z"
          fill="#F6F6F6"
        />
        <path
          d="M25.4808 29.4846V31.5429H4.53027V29.4846H25.4808Z"
          fill="#F6F6F6"
        />
        <path
          d="M4.49771 8.42944H9.73091V10.5045C9.60891 10.511 9.49622 10.5222 9.38445 10.5231C7.87662 10.524 6.36878 10.5166 4.86094 10.5305C4.57036 10.5333 4.48095 10.4477 4.49213 10.1589C4.51355 9.59362 4.49865 9.02643 4.49865 8.43037L4.49771 8.42944Z"
          fill="#F6F6F6"
        />
        <path
          d="M20.2617 10.5063V8.4397H25.5033C25.5033 8.85694 25.5033 9.2807 25.5033 9.70446C25.5033 10.2502 25.2317 10.5231 24.6884 10.5231C23.3426 10.5231 21.9977 10.5231 20.652 10.5231C20.5281 10.5231 20.4033 10.5129 20.2626 10.5063H20.2617Z"
          fill="#F6F6F6"
        />
        <path
          d="M4.5166 23.1131V21.054H9.73024V23.1131H4.5166Z"
          fill="#F6F6F6"
        />
        <path
          d="M20.2617 23.1082V21.0583H25.4707V23.1082H20.2617Z"
          fill="#F6F6F6"
        />
        <path
          d="M8.68019 18.9209H4.52734V16.8552H8.68019V18.9209Z"
          fill="#F6F6F6"
        />
        <path
          d="M21.3096 18.9079V16.8552H25.4755V18.9079H21.3096Z"
          fill="#F6F6F6"
        />
        <path
          d="M4.52344 12.6506H6.57984V14.7173H4.52344V12.6506Z"
          fill="#F6F6F6"
        />
        <path
          d="M25.4763 14.7132H23.4189V12.6438H25.4763V14.7132Z"
          fill="#F6F6F6"
        />
        <path
          d="M16.0283 21.0557V23.1055H13.9775V21.0557H16.0283Z"
          fill="#F6F6F6"
        />
      </svg>
    </div>
  );
}
